import { gql } from '@apollo/client';
import { DictionaryFieldFieldsFragment } from '../../../utils/apollo/fields';

export default gql`
  query GetDictionaryFields(
    $term: String
    $schemaId: ID!
    $func: String
    $context: FieldContext!
    $events: [EventInput!]!
    $includeFields: [String!]!
  ) {
    fields(
      term: $term
      schemaId: $schemaId
      func: $func
      context: $context
      events: $events
      includeFields: $includeFields
    ) {
      ...DictionaryFieldFields
    }
  }
  ${DictionaryFieldFieldsFragment}
`;
